import React, { useState } from 'react'
import './modal.css'
import './form.css'

export default function TryModal({ showModal, setShowModal }) {
    return (
        <div id="myModal" style={{ display: showModal ? 'block' : 'none' }} className="modal">
            <div className="modal-content-try">
                <h1 className='form-title'>Formulaire de demo</h1>

                <div className="form-try">
                    <div className="row-try">
                        <Input label={'Nom'} name={'nom'} type={'text'} />
                        <Input label={'Prenom'} name={'prenom'} type={'text'} />
                    </div>

                    <div className="row-try">
                        <Input label={'Adresse'} name={'adresse'} type={'text'} />
                        <Input label={'Entreprise'} name={'entreprise'} type={'text'} />
                    </div>


                    <Input label={'Fonction'} name={'fonction'} type={'text'} />

                    <TextArea label={'Motif de demande'} name={'motif'} />

                    <Input label={'Date de demo'} name={'date'} type={'date'} />
                </div>

                <div className="form-button-container">      
                    <button className='valid-btn-try' onClick={() => setShowModal(false)}>Envoyer le formulaire</button>
                    <button className='valid-btn-try-cancel' onClick={() => setShowModal(false)}>Fermer</button>
                </div>
            </div>
        </div>
    )
}

const Input = ({ label, type, name }) => {
    return (
        <div className="input-group-try">
            <label className="label-try">{label}</label>
            <input
                autoComplete="off"
                name={name}
                id={name}
                className="input-try"
                type={type}
            />
            <div />
        </div>
    )
}

const TextArea = ({ label, name }) => {
    return (
        <div className="input-group-try">
            <label className="label-try">{label}</label>
            <textarea
                autoComplete="off"
                name={name}
                id={name}
                className="input-try"
                rows={8}
                cols={22}
            />
            <div />
        </div>
    )
}